import authInstance from 'config/axios.config';

export const subCategoryServices = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await authInstance.post('/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  getSubCategories: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.append(key, String(value));
      }
    });

    params.append('level', '1');

    const res = await authInstance.get(`/admin/category?${params}`);
    return res.data;
  },

  toggleActiveStatus: async () => {},

  addSubCategory: async (payload) => {
    const res = await authInstance.post('/admin/category', payload);
    return res.data;
  },

  updateSubCategory: async ({ categoryId, data }) => {
    const res = await authInstance.put(`/admin/category/${categoryId}`, data);
    return res.data;
  },

  deleteMainCategory: async (categoryId) => {
    const res = await authInstance.delete(`/admin/category/${categoryId}/hard-delete`);
    return res.data;
  },

  softDeleteSubCategory: async (categoryId) => {
    const res = await authInstance.delete(`/admin/category/${categoryId}`);
    return res.data;
  },

  toggleActiveStatus: async (categoryId) => {
    const res = await authInstance.patch(`/admin/category/${categoryId}/toggle-active`);
    return res.data;
  },

  exportCategories: async ({
  parentCategory,
  isActive,
  isPopular,
  isFeatured,
  search,
  sortBy,
  sortOrder,
}) => {
  const params = new URLSearchParams({
    level: '1', // Sub Category

    parentCategory:
      parentCategory === 'all'
        ? ''
        : parentCategory || '',

    isActive:
      isActive === 'all'
        ? ''
        : isActive || '',

    isPopular:
      isPopular === 'all'
        ? ''
        : isPopular || '',

    isFeatured:
      isFeatured === 'all'
        ? ''
        : isFeatured || '',

    search: search || '',

    sortBy: sortBy || 'createdAt',

    sortOrder: sortOrder || 'desc',
  });

  for (const [key, value] of [...params.entries()]) {
    if (!value) params.delete(key);
  }

  return authInstance.get(
    `/admin/category/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
